import { defineAbility } from '@casl/ability'

export const abilityPlugin = (store, ability) => {
  return store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'base/SET_RIGHT':
        update(state, ability)
        break
      case 'parantion/user/SET_USER':
        update(state, ability)
        break
      case 'destroySession':
        ability.update([{
          actions: 'read',
          subject: 'all'
        }])
        break
    }
  })
}

function update (state, ability) {
  ability.update(defineAbility(can => {
    const menuInsert = state.base.rights.menu_insert && parseInt(state.base.rights.menu_insert) > 0
    const importStudents = state.parantion && state.parantion.user.roles.includes('overall_addressmanager')
    const overallManager = state.parantion && state.parantion.user.roles.includes('overall_manager')

    if (menuInsert && overallManager) can('create', 'Student')
    if (importStudents) can('import', 'Student')
  }).rules)
}
